const ManuallyCreateLeadEnum = {
  RentOrOwn: [
    { value: 'O', text: 'Own' },
    { value: 'R', text: 'Rent' }
  ],
  Gender: [
    { value: 'M', text: 'Male' },
    { value: 'F', text: 'Female' },
    { value: 'U', text: 'Unknown' }
  ],
  AddressYears: [
    { value: '00', text: '00' },
    { value: '1', text: '01' },
    { value: '2', text: '02' },
    { value: '3', text: '03' },
    { value: '4', text: '04' },
    { value: '5', text: '05' },
    { value: '6', text: '> 05' },
    { value: '10', text: '> 10' },
    { value: '15', text: '> 15' },
    { value: '20', text: '> 20' }
  ],
  AddressMonths: [
    { value: '00', text: '00' },
    { value: '1', text: '01' },
    { value: '2', text: '02' },
    { value: '3', text: '03' },
    { value: '4', text: '04' },
    { value: '5', text: '05' },
    { value: '6', text: '06' },
    { value: '7', text: '07' },
    { value: '8', text: '08' },
    { value: '9', text: '09' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '12', text: '12' }
  ],
  ContactTime: [
    { value: 'A', text: 'Anytime' },
    { value: 'N', text: 'Never' }
  ],
  IncomeType: [
    { value: 'D', text: 'Disablility Income' },
    { value: 'S', text: 'Social Security' },
    { value: 'E', text: 'Employed' },
    { value: 'U', text: 'Unemployed' },
    { value: 'P', text: 'Pension' },
    { value: 'O', text: 'Others (Child Support, Welfare etc.) ' }
  ],
  Paycheck: [
    { value: 'D', text: 'Direct Deposit' },
    { value: 'P', text: 'Paper Check' },
    { value: 'C', text: 'Cash' }
  ],
  JobType: [
    { value: 'F', text: 'Full Time' },
    { value: 'P', text: 'Part Time' }
  ],
  PayrollFrequency: [
    { value: 'W', text: 'Weekly' },
    { value: 'B', text: 'Bi-Weekly' },
    { value: 'S', text: 'Semi-Monthly' },
    { value: 'M', text: 'Monthly' }
  ],
  AccountType: [
    { value: 'C', text: 'Checking Account' },
    { value: 'S', text: 'Savings Account' },
    { value: 'M', text: 'Money Market' }
  ]
}

export default ManuallyCreateLeadEnum
